export type Client = {
  name: string;
  /** Visual treatment of the name in the scrolling band. */
  style?: "spaced" | "heavy";
};

export const CLIENTS: Client[] = [
  { name: "Trvlar" },
  { name: "Vera InkJet" },
  { name: "Nicole Benisti", style: "spaced" },
  { name: "JVM Auto", style: "heavy" },
  { name: "VRT Solutions" },
];

export type Testimonial = {
  /** Excerpt shown in the UI — verbatim words from the client. */
  quote: string;
  /** Part of the quote to emphasise (must appear in `quote`). */
  emphasis?: string;
  author: string;
  role: string;
  /** Full testimonial as the client wrote it (for Work/About pages). */
  full?: string;
  placeholder?: boolean;
};

/** First entry is the featured quote on Home. */
export const TESTIMONIALS: Testimonial[] = [
  {
    quote:
      "They were able to keep the team on track, communicated progress effectively, and handled challenges with ease.",
    emphasis: "handled challenges with ease.",
    author: "Trvlar",
    role: "Mobile & web partner",
    // Only change from the original: the company name's spelling is fixed.
    full:
      "Trvlar had the pleasure of working with Infinitude Stack for the past years in mobile app and web development capacities. Infinitude has an outstanding software developers who truly excelled in every aspect. Their attention to details and app development skills are top-notch, crafting a user-friendly interface embedded with seamless functionality. What truly sets Infinitude Stack apart is their remarkable project management skills that complements their software development acumen. They were able to keep the team on track, communicated progress effectively, and handled challenges with ease. Beyond their technical prowess, Infinitude Stack is a delight to work with approachable and open to ideas.",
  },
  {
    quote: "Excellent service at a fair price. Would recommend.",
    emphasis: "Would recommend.",
    author: "Vera InkJet",
    role: "Client",
  },
];

/** Industries we've worked in — each backed by real clients above. */
export const INDUSTRIES = [
  { title: "Travel & hospitality", text: "Trvlar — a website plus iOS and Android apps for planning trips with friends." },
  { title: "Fashion", text: "Nicole Benisti — a Montreal luxury outerwear house selling worldwide on Shopify." },
  { title: "Automotive", text: "JVM Auto and VRT Solutions — a shop admin panel and a garage app for technicians." },
  { title: "Commerce", text: "Online stores, bilingual sites and checkout flows that customers can rely on." },
];

/** One-line summary used on Home. */
export const INDUSTRY_LINE = "Travel & hospitality · Fashion · Automotive · Commerce";
